import { FC, memo } from 'react';

import { IconBase, IconBaseProps, matchSize } from './IconBase';

const IconMinusSmall: FC<IconBaseProps> = memo(props => {
  return (
    <IconBase {...props} width="18" height="2" viewBox="0 0 18 2">
      <path d="M0 1H18" stroke="black" strokeWidth="2" />
    </IconBase>
  );
});

const IconMinusLarge: FC<IconBaseProps> = memo(props => {
  return (
    <IconBase {...props} width="36" height="2" viewBox="0 0 36 2">
      <path d="M1 1H37" stroke="black" strokeWidth="2" strokeLinecap="round" />
    </IconBase>
  );
});

export const IconMinus: FC<IconBaseProps> = memo(props => {
  const { size } = props;
  const Icon = matchSize(size, {
    s: IconMinusSmall,
    otherwise: IconMinusLarge,
  });

  return <Icon {...props} />;
});
